import script from "./addEcosystem.vue?vue&type=script&setup=true&lang=ts"
export * from "./addEcosystem.vue?vue&type=script&setup=true&lang=ts"

import "./addEcosystem.vue?vue&type=style&index=0&id=3f6b934d&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f6b934d"]])

export default __exports__